import React from 'react'
import { Grid, Typography } from '@mui/material'
import { useI18n } from '@ggs/i18n'
import { ShowRoom } from './ShowRoom'
import { SalesPersons } from './SalesPersons'

/**
 * @typedef {import('../../../definitions').RepResponse} RepResponse
 */

/**
 * @typedef {Object} RepLocatorListProps
 * @property {RepResponse} reps
 */

/**
 * Rep locator list.
 * @param {RepLocatorListProps} props
 * @return {JSX.Element}
 */
export const RepLocatorList = ({ reps }) => {
  const { t } = useI18n()

  /**
   * Callback to check if RepResponse empty or not.
   * @param {RepResponse} reps
   * @return {boolean}
   */
  const repsIsEmpty = (reps) => {
    if (!reps) {
      return true
    }

    if ('salesDirectors' in reps && reps.salesDirectors.length > 0) {
      return false
    } else if ('showRoom' in reps && reps.showRoom) {
      return false
    } else if ('territories' in reps) {
      if ('subTerritories' in reps.territories && reps.territories.subTerritories.length > 0) {
        return false
      } else if ('salesReps' in reps.territories && reps.territories.salesReps.length > 0) {
        return false
      }
    }
    return true
  }

  return (
    <>
      {reps && (
        <Grid className="rep-locator-view__reps-data">
          {repsIsEmpty(reps) ? (
            t('No results found')
          ) : (
            <>
              {reps.territories.name && (
                <Typography variant={'h2'}>
                  {t('{{name}} Team', { name: reps.territories.name === 'District of Columbia' ? 'Washington D.C.' : reps.territories.name }
                  )}
                </Typography>
              )}
              {(reps.showRoom || reps.salesDirectors.length > 0) && (
                <div className="rep-locator-view__items">
                  {reps.showRoom && (
                    <ShowRoom showRoom={reps.showRoom} />
                  )}
                  {reps.salesDirectors.length > 0  && (
                    <SalesPersons salesPersons={reps.salesDirectors} title={t('Regional Sales Directors')} />
                  )}
                </div>
              )}
              {(reps.territories.salesReps.length > 0 || reps.territories.subTerritories.length > 0) && (
                <Typography className="rep-locator-view__sales-title" variant={'h3'}>{t('Sales Reps')}</Typography>
              )}
              {reps.territories.salesReps.length > 0 && (
                <SalesPersons salesPersons={reps.territories.salesReps} />
              )}
              {reps.territories.subTerritories.length > 0 && (
                <SalesPersons salesPersons={reps.territories.subTerritories} />
              )}
            </>
          )}
        </Grid>
      )}
    </>
  )
}
